import { baseApi } from './base';
import { Option } from '../domain/reference-data';
import { State, StateCodes } from '../domain/state';

const byCode = (a: StateCodes, b: StateCodes) => {
  return a.name < b.name ? -1 : 1;
};

export const referenceDataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIndustries: builder.query<Option[], void>({
      query: () => ({
        method: 'GET',
        url: 'qualification/ref_data/industries',
      }),
    }),

    getBusinessTypes: builder.query<Option[], void>({
      query: () => ({
        method: 'GET',
        url: 'qualification/ref_data/business_types',
      }),
      transformResponse: (response: string[]) =>
        response.map((s) => {
          if (s === 'Corporation') {
            return { id: s, name: 'Corporation (C-Corp or S-Corp)' };
          }

          return { id: s, name: s };
        }),
    }),

    getStates: builder.query<Option[], void>({
      query: () => ({
        method: 'GET',
        url: 'qualification/ref_data/states',
      }),
      transformResponse: (response: State[]) =>
        response
          .map(({ code }) => ({
            id: code,
            name: code,
          }))
          .sort(byCode),
    }),
  }),
  overrideExisting: false,
});

export const { useGetIndustriesQuery, useGetBusinessTypesQuery, useGetStatesQuery } = referenceDataApi;
